// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"d9c0611b","235":"b546ac2e"}[chunkId] + ".chunk.css";
};